// extracted by mini-css-extract-plugin
module.exports = {"siderMenu":"siderMenu--2G5U9"};